import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO meta wrapper.
 * Pass { title, description, path } — the rest defaults to brand-wide values.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = "/hero-rainbow.jpg",
}) {
  const fullTitle = title
    ? `${title} — Infinity DMS`
    : "Infinity DMS — Telecoms & Cellular Contracts for SA Business";
  const desc =
    description ||
    "One trusted partner for MTN, Vodacom, Cell C, Vox and Telkom contracts, fibre, VoIP and managed connectivity in South Africa.";
  const canonical = `https://infinity-dms.co.za${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
